import { useEffect } from "react";
import {
  dispatchNarrativeFlowOpen,
  parseNarrativeFlowOpenUrl,
  storePendingNarrativeFlowOpen,
} from "../../lib/narrativeflow-desktop-open";

export function NarrativeFlowDesktopBridge() {
  useEffect(() => {
    const bridge = window.electron?.onNarrativeFlowOpen;
    if (!bridge) return;

    const openNarrativeFlow = (url: string) => {
      const target = parseNarrativeFlowOpenUrl(url);
      if (!target) return;
      storePendingNarrativeFlowOpen(target);
      window.dispatchEvent(
        new CustomEvent("fintheon:navigate-tab", {
          detail: { tab: "analysis" },
        }),
      );
      window.setTimeout(() => {
        window.dispatchEvent(new Event("fintheon:open-narrativeflow"));
        dispatchNarrativeFlowOpen(target);
      }, 120);
    };

    bridge(openNarrativeFlow);
    return () => window.electron?.onNarrativeFlowOpen?.(null);
  }, []);

  return null;
}
